module.exports = __webpack_public_path__ + "img/letras_healthtech_orozco.9bcf4f81.jpg";